/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Factor } from './Factor';
import {
    FactorFromJSON,
    FactorFromJSONTyped,
    FactorToJSON,
    FactorToJSONTyped,
} from './Factor';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
    PersonHandleToJSONTyped,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface IDRequest
 */
export interface IDRequest {
    /**
     * 
     * @type {PersonHandle}
     * @memberof IDRequest
     */
    handle?: PersonHandle;
    /**
     * 
     * @type {Factor}
     * @memberof IDRequest
     */
    factor?: Factor;
}

/**
 * Check if a given object implements the IDRequest interface.
 */
export function instanceOfIDRequest(value: object): value is IDRequest {
    return true;
}

export function IDRequestFromJSON(json: any): IDRequest {
    return IDRequestFromJSONTyped(json, false);
}

export function IDRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'] == null ? undefined : PersonHandleFromJSON(json['handle']),
        'factor': json['factor'] == null ? undefined : FactorFromJSON(json['factor']),
    };
}

export function IDRequestToJSON(json: any): IDRequest {
    return IDRequestToJSONTyped(json, false);
}

export function IDRequestToJSONTyped(value?: IDRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': PersonHandleToJSON(value['handle']),
        'factor': FactorToJSON(value['factor']),
    };
}

